'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MethodType = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

var _CallStateFSM = require('./CallStateFSM');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MethodType = exports.MethodType = function (_Enum) {
    _inherits(MethodType, _Enum);

    function MethodType() {
        _classCallCheck(this, MethodType);

        return _possibleConstructorReturn(this, (MethodType.__proto__ || Object.getPrototypeOf(MethodType)).apply(this, arguments));
    }

    _createClass(MethodType, [{
        key: 'createCallStateMachine',
        value: function createCallStateMachine() {
            switch (this.name) {
                case 'COMMAND':
                    return (0, _CallStateFSM.createCommandStateMachine)();
                case 'QUERY':
                    return (0, _CallStateFSM.createQueryStateMachine)();

                default:
                    throw new Error('unknown type \'' + this.name + '\'');
            }
        }
    }]);

    return MethodType;
}(_nestedHateoasCommonModels.Enum);

MethodType.initEnum(['COMMAND', 'QUERY']);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/MethodType.js
// module id = 343
// module chunks = 118